import { COPY } from './copy';

/**
 * The room's verdict on a question. Every answer area already shows the room's split (a share on each answer, the credit
 * bar, the histogram), so this says something only when nobody answered: there is then no split to read.
 */
export function RoomStamp({ pct, className = '' }: { pct?: number; className?: string }) {
  if (pct !== undefined) return null;
  return <p className={`text-sm text-ink-3 ${className}`}>{COPY.reveal.nobody}</p>;
}
